angular.module('wbDashboard').controller('PlansDetailFeatureQuickdepositControllerAurea', ['$scope', '$uibModal', 'NgTableParams', function ($scope, $uibModal, NgTableParams) {
    /*jshint -W030 */
    $scope.localData || ($scope.localData = {});
    /*jshint +W030 */

    $scope.$watch('overview', function(overview) {
        if (overview) {
        }
    });

    $scope.localData.initialTab = function () {
        return "about";
    };
    $scope.localData.hideDetail = function () {
        return true;
    };

    if ($scope.setFeatureTabs) {
        $scope.setFeatureTabs();
    }

    $scope.toggleFeature.onMessage = "Speeding up those deposits.";
    $scope.toggleFeature.offMessage = "You can turn this back on at any time.";

}]);
